import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';


import * as urlUtils from '../../utils/urlUtils';

import {CartProvider} from '../contexts/Cart';
import {GlobalConfiguration, UserConfiguration} from '../contexts/Config';
import {buyConstants} from '../modules/Buy';
import {useIsAuthenticated, useLogin} from '../contexts/Auth';


function PrivateRouteContext({canAccess, children}) {

    const isAuthenticated = useIsAuthenticated();
    const login = useLogin();
    const navigate = useNavigate();

    // redirect with sign-in using current-url for return
    if (!isAuthenticated) {

        const redirectUri = urlUtils.getUrl();

        return login({redirectUri});
    }

    // and if access not grated (e.g. due to permissions) -> start
    if (!canAccess) {

        return navigate(buyConstants.NAV_BUY_OVERVIEW_PAGE);
    }

    return (
        <GlobalConfiguration>
            <UserConfiguration>
                <CartProvider>

                    {children}

                </CartProvider>
            </UserConfiguration>
        </GlobalConfiguration>
    );
}


PrivateRouteContext.propTypes = {
    canAccess: PropTypes.bool,
    children: PropTypes.any.isRequired
};

PrivateRouteContext.defaultProps = {
    canAccess: true
};


export default PrivateRouteContext;
